const ProjectRow = function($containerEl, projectModel)
{
    TemplateView.call(this, $containerEl);
    this.projectModel = projectModel;
};

ProjectRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='projectRow'>" +
          "  <td class='nameColumn'><div class='subContainer'><%-name%></div></td>" +
          "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
          "  <td class='detailsColumn'></td>" +
          "</tr>",

    templateModel: function()
    {
        return {
            name: ViewTTStore.getProject(this.projectModel.projectId).name,
            total: UserTime.formatTimeWithDigitSeparator(this.projectModel.totalSpent)
        }
    }
});

export default ProjectRow


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ProjectRow.js